<template>
    <div>
        
    </div>
</template>
<script>
import  user_service from "@/service/user_service.js";
export default {
    data() {
        return {
            
        }
    },
    async created(){
        console.log(this.$route.query.code);
        if(this.$route.query.code) {
            // 获取code
            const code = this.$route.query.code;
            try {
                let {access_token, expires_in, refresh_token} = await user_service.oauth2Token(code);
                this.$cookie.set('access_token', access_token, {maxAge: 1000 * expires_in * 0.5});
                this.$cookie.set('refresh_token', refresh_token, {maxAge: 1000 * 60 * 60 * 6});
                this.$router.push('/home');
            } catch (error) {
                this.$router.push('/');
            }
           
        }else {
            this.$router.push('/');
        }
        
        
    }
}
</script>



// WEBPACK FOOTER //
// src/components/back.vue